import { render, staticRenderFns } from "./promotions-product-detail.vue?vue&type=template&id=7ceb1662&scoped=true&"
import script from "./promotions-product-detail.vue?vue&type=script&lang=js&"
export * from "./promotions-product-detail.vue?vue&type=script&lang=js&"
import style0 from "./promotions-product-detail.vue?vue&type=style&index=0&id=7ceb1662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceb1662",
  null
  
)

export default component.exports